import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      title={isDark ? "Passer en mode clair" : "Passer en mode sombre"}
      aria-label={isDark ? "Activer le mode clair" : "Activer le mode sombre"}
      data-testid="theme-toggle"
      className={`inline-flex items-center justify-center w-9 h-9 rounded-full border transition hover:scale-105 active:scale-95 ${className}`}
      style={{
        borderColor: "var(--sl-border)",
        background: "var(--sl-card-bg)",
        color: "var(--sl-text)",
      }}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
